import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function SpeedFast({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M13.4101 11.59L18.5001 6.49997M20.1801 9.30997C21.8801 13.03 20.8401 17.43 17.6401 19.99M15.6801 4.80997C14.5201 4.26997 13.2601 3.99997 11.9901 3.98997L11.9891 3.98897C7.01906 3.97897 2.98906 8.00897 2.97906 12.979C2.96906 15.699 4.20906 18.269 6.31906 19.979M12.0001 10.99C11.4696 10.99 10.9609 11.2007 10.5859 11.5758C10.2108 11.9508 10.0001 12.4595 10.0001 12.99C10.0001 13.5204 10.2108 14.0291 10.5859 14.4042C10.9609 14.7793 11.4696 14.99 12.0001 14.99C12.5305 14.99 13.0392 14.7793 13.4143 14.4042C13.7893 14.0291 14.0001 13.5204 14.0001 12.99C14.0001 12.4595 13.7893 11.9508 13.4143 11.5758C13.0392 11.2007 12.5305 10.99 12.0001 10.99Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default SpeedFast;